import { motion } from 'framer-motion';
import useReducedMotion from '../../hooks/useReducedMotion';

/** Fade/slide wrapper applied to each routed page. */
export default function PageTransition({ children }) {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) return <main id="main">{children}</main>;

  return (
    <motion.main
      id="main"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.main>
  );
}
